import React from 'react';

class FieldsDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelection = this.handleSelection.bind(this);
  }

  handleSelection(e) {
    const optionValueArray = e.target.value.split('|');
    const operatorName = optionValueArray[0];
    const relatedObjectId = optionValueArray[1]
      ? Number(optionValueArray[1])
      : null;
    this.props.setOperator(operatorName, relatedObjectId);
  }

  static optionValue(field) {
    if (field.relatedObjectId) {
      return field.name + '|' + field.relatedObjectId;
    }
    return field.name;
  }

  // whenever new key adding inside the groupFields in backend
  // keep in mind to add i18n translation value respctive to new keys
  groupedFieldsLabel(label, field) {
    const fieldLabels = {
      group_manager: t('smart_groups.rule_type.group_manager'),
      group_membership: t('smart_groups.rule_type.group_membership'),
      user_business_unit: t('smart_groups.rule_type.user_business_unit'),
      user_created_at: t('smart_groups.rule_type.user_created_at'),
      user_department: t('smart_groups.rule_type.user_department'),
      user_email: t('smart_groups.rule_type.user_email'),
      user_hire_date: t('smart_groups.rule_type.user_hire_date'),
      user_job_title: t('smart_groups.rule_type.user_job_title'),
      user_locale: t('smart_groups.rule_type.user_locale'),
      user_location: t('smart_groups.rule_type.user_location'),
      user_manager_name: t('smart_groups.rule_type.user_manager_name'),
      user_name: t('smart_groups.rule_type.user_name'),
      user_role: t('smart_groups.rule_type.user_role'),
    };
    if (label === 'Custom Fields') {
      return field.humanName;
    }
    return fieldLabels[field.name] || '';
  }

  render() {
    const { name, groupedFields } = this.props;
    return (
      <select
        className="Rule-select"
        value={name || ''}
        onChange={this.handleSelection}
        aria-label={t('smart_groups.create_modal.choose_rule_type')}
      >
        <option disabled value="">
          {t('smart_groups.create_modal.choose_rule_type')}
        </option>
        {Object.keys(groupedFields).map(label => (
          <optgroup label={label} key={label}>
            {groupedFields[label].map(field => (
              <option
                key={FieldsDropdown.optionValue(field)}
                value={FieldsDropdown.optionValue(field)}
              >
                {this.groupedFieldsLabel(label, field)}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    );
  }
}

export default FieldsDropdown;
